import React from 'react';
import styled, { css } from 'styled-components';
import { Button } from '../../Atoms/Button';
import { P3 } from '../../Atoms/Typo';

const Component = styled.div<{ $activeID: number }>`
  display: flex;
  align-items: center;

  button {
    width: 140px;
    height: 40px;
    ${P3} {
      font-size: 15px;
      font-weight: 600;
    }

    background-color: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors.grey900};
    border-radius: 6px;

    :first-child {
      margin-right: 6px;
    }
    :last-child {
      margin-left: 6px;
    }
  }

  ${(props) => {
    return css`
      button {
        :nth-child(${props.$activeID + 1}) {
          ${P3} {
            color: white;
          }

          background-color: ${props.theme.colors.grey900};
        }
      }
    `;
  }}
`;

interface ButtonGroupProps {
  buttonData: {
    id: number;
    title: string;
  }[];
  activeID: number;
  className?: string;
  onClick?: (id: number) => void;
}

const ButtonGroup = ({
  buttonData,
  activeID,
  className,
  onClick,
}: ButtonGroupProps) => {
  const onClickButton = (id: number) => {
    if (onClick) {
      onClick(id);
    }
  };

  return (
    <Component $activeID={activeID} className={className}>
      {buttonData.map((element) => {
        return (
          <Button
            key={element.id}
            onClick={() => {
              onClickButton(element.id);
            }}
          >
            <P3>{element.title}</P3>
          </Button>
        );
      })}
    </Component>
  );
};

export default ButtonGroup;
